
import { CommonOktaStyling } from './CommonStyling';
import classess from './OktaSignInWidget.scss';
import { maskEmail } from './oktaUtils';

function OktaEmailScreenCssHelperAlt() {
  
  const titleElement = document.querySelector('.okta-form-title');
  if (titleElement) {
    titleElement.textContent = 'Log Into SCE.com';
    titleElement.classList.add(classess.popUpTitle);
  }

  const emailElement = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier');
  if (emailElement) {
    const emailInText = document.querySelector("#okta-sign-in .siw-main-view .siw-main-body span.strong");
    if (emailInText) {
      emailInText.textContent = maskEmail(emailElement.textContent);
    }
    emailElement.classList.add(classess.emailText);
    emailElement.textContent = maskEmail(emailElement.textContent);
  }
  const emailElementParentDiv = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier-container');
  const parentElement=document.querySelector('#okta-sign-in .auth-content .o-form-content');
  const verifyElement= document.querySelector('#okta-sign-in .auth-content .o-form-content .verify-message');
  //adding the emailElement after LogIn text
  if ( emailElementParentDiv && parentElement && verifyElement) {
    parentElement.insertBefore(emailElementParentDiv, verifyElement);
  }
}
function OktaEmailScreenCssHelper () {

  const sendEmailContent = document.querySelector('#okta-sign-in.auth-container .okta-form-subtitle');
  if (sendEmailContent) {
    sendEmailContent.style.marginTop = CommonOktaStyling.MARGIN_NONE;
    sendEmailContent.style.textAlign = CommonOktaStyling.TEXT_ALIGN_LEFT;
    sendEmailContent.classList.add(classess.textSizeS) ;
    if (!document.querySelector('.click-message')) {
      const emailClickContent = document.createElement('div');
      emailClickContent.className = 'click-message';
      emailClickContent.textContent = 'Enter the code below';
      sendEmailContent.innerHTML = sendEmailContent.innerHTML.split('Enter')[0];
      sendEmailContent.appendChild(emailClickContent);
    }
  }

  const resendLink = document.getElementsByClassName('resend-link');
  if(resendLink.length !== 0){
    resendLink[0].setAttribute('href','javascript:void(0)');
  }

  const codeInput = document.querySelector('input[name="credentials.passcode"]');
  if (codeInput) {
    codeInput.addEventListener('input', function (event) {
      // Remove any non-numeric characters
      codeInput.value = codeInput.value.replace(/[^0-9]/g, '');
    });
    codeInput.style.boxShadow = CommonOktaStyling.BOX_SHADOW;
    codeInput.maxLength = 6;
  }

  const inputButton = document.querySelector('input[type="submit"]');
  if (inputButton) {
    const verifyButton = document.createElement('button');
    verifyButton.type = 'submit';
    verifyButton.textContent = inputButton.value;
    verifyButton.classList.add(classess.button,classess.textTypography,'button-primary');
    verifyButton.setAttribute('data-type',inputButton.getAttribute('data-type'));
    verifyButton.style.width = '100%';
    verifyButton.style.height = CommonOktaStyling.HEIGHT_L;
    verifyButton.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_BOLD;
    verifyButton.style.fontSize = CommonOktaStyling.FONT_SIZE_SM;
    verifyButton.style.border = CommonOktaStyling.BORDER;
    verifyButton.style.borderRadius = CommonOktaStyling.BORDER_RADIUS;
    verifyButton.style.padding = CommonOktaStyling.PADDING;
    verifyButton.style.lineHeight = CommonOktaStyling.LINE_HEIGHT_L;
    verifyButton.style.color = CommonOktaStyling.TEXT_COLOR_BLACK;
    verifyButton.style.background = CommonOktaStyling.BACKGROUND_COLOR_BUTTON;
    verifyButton.style.textTransform = CommonOktaStyling.TEXT_TRANSFORM_UPPERCASE;
    inputButton.parentElement.replaceChild(verifyButton,inputButton);
  }

}

export default function OktaEmailScreenCss(emailIcon) {
    
  const headerElement = document.querySelector('#okta-sign-in .siw-main-header .beacon-container');
  if(headerElement){
    headerElement.style.display = 'none';
  }


  const verifyMessage = document.createElement('div');
  if (!document.querySelector('.verify-message')) {
    verifyMessage.className = 'verify-message';
    verifyMessage.style.display = 'flex';
    verifyMessage.style.alignItems = 'center';
    verifyMessage.style.marginTop = CommonOktaStyling.MARGIN_L;

    const verifyImage = document.createElement('div');
    verifyImage.style.backgroundImage = `url(${emailIcon})`;
    verifyImage.style.height = '32px';
    verifyImage.style.width = '32px';
    verifyImage.style.marginRight = '10px';

    const verifyContent = document.createElement('div');
    verifyContent.textContent = 'Verify with Your Email';
    verifyContent.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_BOLD;
    verifyContent.style.color = CommonOktaStyling.TEXT_COLOR_GREY;
    verifyContent.style.textAlign = CommonOktaStyling.TEXT_ALIGN_LEFT;
    verifyContent.style.fontSize = CommonOktaStyling.FONT_SIZE_SL;
    verifyContent.style.lineHeight = CommonOktaStyling.LINE_HEIGHT_S ;
    verifyContent.classList.add(classess.textSizeSM);
    verifyMessage.appendChild(verifyImage);
    verifyMessage.appendChild(verifyContent);

    const refElement = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier-container');
    if (refElement) {
      refElement.parentNode.insertBefore(verifyMessage, refElement);
      refElement.style.textAlign = CommonOktaStyling.TEXT_ALIGN_LEFT;
      refElement.style.marginTop = CommonOktaStyling.MARGIN_SM;
      refElement.style.marginBottom = CommonOktaStyling.MARGIN_NONE;
      refElement.style.display='flex';
      refElement.style.justifyContent='center';
      refElement.classList.add(classess.humanLogoVerifyScreen);
    }
  }

  
  const label = document.querySelectorAll('#okta-sign-in.auth-container .okta-form-label');
  if (label) {
    label.forEach(el => {
      if (!el.innerHTML.includes('*')) {
        el.innerHTML += '<span style="color: #BB0000;">*</span>';
      }
      el.childNodes[0].classList.add(classess.formLabel);
    });
  }


  OktaEmailScreenCssHelper();
  OktaEmailScreenCssHelperAlt();

  const warningIcon = document.querySelector('#okta-sign-in .infobox-warning > .icon');
  if(warningIcon){
    warningIcon.classList.add(classess.warningIcon);
  }
  const warningIconDiv = document.querySelector('#okta-sign-in .infobox-warning');
  if(warningIconDiv){
    warningIconDiv.classList.add(classess.warningIconDiv);
  }

}